module.exports = __webpack_public_path__ + "static/sql-8258679a6ba37976ee3a6151aac329d8.png";